import React from 'react'
import PropTypes from 'prop-types'

const DividerHorizontal = ({
  paddingThickness = 'pb-px',
  color = 'bg-secondary-graywhite',
  className,
}) => <div className={`w-full ${paddingThickness} ${color} ${className}`} />

DividerHorizontal.propTypes = {
  paddingThickness: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default DividerHorizontal
